import React from 'react';
import { UUID } from '../../types/shared/UUID';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { NavigationItem } from '../../ui-toolkit';
import { IStandardDocumentData, IStandardDocumentVersionData } from '../../types/order/documents/shared/interfaces';
import { ClientDocumentActivityCell } from '../../components/clientPortal/orderOverview/ClientDocumentActivityCell';
import { RightAlignedDiv } from '../../components/shared/RightAlignedDiv';
import { IDocumentCategory } from '../../types/order/documents/IDocumentCategoryType';
import { DateFormat, getDateString } from '../../ui-toolkit/utilities/getDateString';

export const generateClientColumns = ({
  setPreviewDoc,
  orderId,
  documentCategoriesByName,
}: {
  setPreviewDoc: (doc: IStandardDocumentVersionData) => void;
  orderId: UUID;
  documentCategoriesByName: Record<string, IDocumentCategory>;
}): IBootstrapTableColumnProps<IStandardDocumentVersionData>[] => {
  return [
    {
      text: 'File',
      dataField: 'fileName',
      formatter: (cell: any, row?: IStandardDocumentVersionData) =>
        row && <NavigationItem text={cell} onClick={() => setPreviewDoc(row)} isInline />,
      sort: true,
    },
    {
      text: 'Category',
      dataField: 'category',
      formatter: (cell: string | any) => {
        const doc = documentCategoriesByName[cell];
        return doc?.label;
      },
      sort: true,
    },
    {
      text: 'Updated',
      dataField: 'updatedAt',
      formatter: updatedAtFormatter,
      headerStyle: { textAlign: 'right' as 'right', width: '40%' },
      sort: true,
    },
    {
      text: 'Action',
      dataField: 'versioned',
      formatter: (_: any, row?: IStandardDocumentData) =>
        row && <ClientDocumentActivityCell document={row} orderId={orderId} />,
      sort: true,
    },
  ];
};

const updatedAtFormatter = (cell: any) => (
  <RightAlignedDiv>{getDateString(DateFormat.hugeDateTime, cell, true)}</RightAlignedDiv>
);
